import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DiningPlanComponent } from '../plan/plan.component';

@Component({
    selector: 'finder-dining-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: true,
    imports: [CommonModule, DiningPlanComponent]
})
export class DiningPlansTableComponent implements OnInit {

    @Input() mealPeriods: Array<string>;
    @Input() years: any;
    @Input() plans: any;
    @Input() singleYear: boolean;
    @Input() title: string;

    notAccepted: string;
    mealPeriodClass: string;

    constructor() { }

    ngOnInit() {
        // Each table instance needs its own reference to the Meal Periods array.
        this.mealPeriods = [...this.mealPeriods];
        // Translation key used when a meal period is not accepted.
        this.notAccepted = this.mealPeriods.pop();
        this.mealPeriodClass = this.getMealPeriodClass();
    }

    getMealPeriodClass() {
        switch (this.mealPeriods.length) {
            case 1: return 'one-meal';
            case 2: return 'two-meals';
            case 3: return 'three-meals';
            case 4: return 'four-meals';
            default: return '';
        }
    }
}
